module.exports = "/_next/static/images/video_id_7124379008812338474-cde96604d4db37e2777381c61227daff.jpg";